import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, Row, UiBox, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {Stage} from '~/types/models/questionnaire';

interface Props {}

const Questionnaire10PillScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION_PILL);

  const collectedData = mdq.collectedData;

  const renderSteps = (step: {key: string; title: string; description: string}, isActiveStage: boolean) => {
    const isActiveStep = isActiveStage && step.key === 'STEP_2';
    return (
      <Row mt={2} key={step?.key} px={2}>
        <UiBox
          style={{
            width: '1px',
            height: '100%',
            borderLeft: '1px dashed #2C414233',
            position: 'relative',
          }}
        >
          <UiBox
            style={{
              width: isActiveStep ? '1rem' : '0.5rem',
              height: isActiveStep ? '1rem' : '0.5rem',
              borderRadius: '50%',
              position: 'absolute',
              left: 0,
              top: 10,
              transform: 'translateX(-55%)',
            }}
            bg={isActiveStep ? 'lightBaseColor' : '#2C414233'}
          />
        </UiBox>
        <Col align="flex-start" w="100%" ml={5} textAlign="left" mb={2}>
          <UiText fontSize="sm" fontWeight={600} w="100%">
            {step.title}
          </UiText>
          <UiText fontSize="xs" fontWeight={500} opacity={0.6} w="100%">
            {step.description}
          </UiText>
        </Col>
      </Row>
    );
  };

  const renderStage = (stage: Stage) => {
    const isActiveStage = stage?.key === 'STAGE_1';
    return (
      <Col key={stage?.key} align="flex-start" w="100%" textAlign="left">
        <UiText fontWeight={600} mb={1}>
          {stage?.title}
        </UiText>
        <UiText fontSize="xs" fontWeight={500} opacity={0.6}>
          {stage?.description}
        </UiText>
        {stage?.steps?.map(step => renderSteps(step, isActiveStage))}
      </Col>
    );
  };

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION_PILL,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION_PILL]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES}));
    history.push(PAGE_URLS.MDQ1_APPOINTMENT_PREFERENCES);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={4}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map((item, index) => {
          return (
            <UiText key={index} fontSize="sm" mt={4}>
              {item}
            </UiText>
          );
        })}
        <Col mt={14} w="100%" ml={4}>
          {questionnaire?.stages?.map(stage => renderStage(stage))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire10PillScreen;
